import axios from 'axios';
import { VideoStatus } from '../types/video.types';

const BASE = `${process.env.REACT_APP_API_URL ?? 'http://localhost:8000/api/v1'}/videos`;

const authHeader = (token: string) => ({ Authorization: `Bearer ${token}` });
const multipart  = (token: string) => ({ ...authHeader(token), 'Content-Type': 'multipart/form-data' });

export const videoService = {
    fetchPublic: (audience = 'ALL') =>
        axios.get(`${BASE}/public`, { params: { audience } }),

    fetchAll: (token: string, page = 1, limit = 10, status?: string, sortBy?: string, sortOrder?: string) =>
        axios.get(BASE, {
            headers: authHeader(token),
            params: {
                page, limit,
                ...(status    ? { status }    : {}),
                ...(sortBy    ? { sortBy }    : {}),
                ...(sortOrder ? { sortOrder } : {}),
            },
        }),

    fetchById: (token: string, id: string) =>
        axios.get(`${BASE}/${id}`, { headers: authHeader(token) }),

    create: (token: string, formData: FormData) =>
        axios.post(BASE, formData, { headers: multipart(token) }),

    update: (token: string, id: string, formData: FormData) =>
        axios.put(`${BASE}/${id}`, formData, { headers: multipart(token) }),

    toggleStatus: (token: string, id: string, status: VideoStatus) =>
        axios.patch(`${BASE}/${id}/status`, { status }, { headers: authHeader(token) }),

    delete: (token: string, id: string) =>
        axios.delete(`${BASE}/${id}`, { headers: authHeader(token) }),

    trackImpression: (id: string) =>
        axios.post(`${BASE}/${id}/track-impression`),
};
